import { useEffect, useState } from "react";
import { Button, Input, Space, Tag, Modal } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";

// Tek "Onay Al" butonu → modal: kanal seç (SMS/E-posta) → kod gir → onayla.
// Belirtilen sözleşme türü (documentType, ör. TICARI) için. "Skip" yoktur; onay opsiyoneldir.
export default function PatientKvkk({ patientId, documentType = 'TICARI', label, onApproved }) {
    const [open, setOpen] = useState(false);
    const [code, setCode] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(false);
    const [approved, setApproved] = useState(false);
    const [loading, setLoading] = useState(false);
    const [patient, setPatient] = useState({});

    const load = async () => {
        const p = await ApiService.Patient.GetPatient(patientId);
        if (p.success) setPatient(p.data);
        const c = await ApiService.Patient.IsConsentApproved(patientId, documentType);
        if (c.success) setApproved(!!c.data);
    };

    useEffect(() => { load(); }, [patientId, documentType]);

    const openModal = () => { setOpen(true); setSent(false); setCode(""); setError(false); };

    const sendCode = async (channel) => {
        setError(false);
        setLoading(true);
        try {
            const res = await ApiService.Patient.SendConsentCode(patientId, documentType, channel);
            if (res.success) setSent(true);
        } finally {
            setLoading(false);
        }
    };

    const approve = async () => {
        const res = await ApiService.Patient.ApproveConsent(patientId, documentType, { code });
        if (res.success && res.data) {
            setApproved(true);
            setOpen(false);
            onApproved && onApproved();
        } else {
            setError(true);
        }
    };

    if (approved) {
        return <Tag icon={<CheckCircleOutlined />} color="success">{t('Approved')}</Tag>;
    }

    return (
        <>
            <Button size="small" onClick={openModal}>{label || t('Get Approval')}</Button>
            <Modal
                title={label || t('Get Approval')}
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                destroyOnClose
                centered
                width={440}
            >
                {!sent ? (
                    <div style={{ textAlign: 'center', padding: '12px 0' }}>
                        <div style={{ marginBottom: 20, fontSize: 15 }}>{t('Send the approval code via which channel?')}</div>
                        {(patient?.phone1 || patient?.email) ? (
                            <Space size="middle">
                                {patient?.phone1 && (
                                    <Button type="primary" size="large" loading={loading} onClick={() => sendCode('phone')}>{t('SMS')}</Button>
                                )}
                                {patient?.email && (
                                    <Button size="large" loading={loading} onClick={() => sendCode('email')}>{t('Email')}</Button>
                                )}
                            </Space>
                        ) : (
                            <div style={{ color: 'red' }}>{t('No phone or email on file for this patient.')}</div>
                        )}
                    </div>
                ) : (
                    <Space direction="vertical" size="middle" style={{ width: '100%', padding: '8px 0' }}>
                        <div style={{ fontSize: 15 }}>{t('Enter the code sent to the patient.')}</div>
                        <Input
                            size="large"
                            placeholder={t('Enter Code')}
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            onPressEnter={approve}
                            autoFocus
                            style={{ textAlign: 'center', letterSpacing: 4, fontSize: 18 }}
                        />
                        {error && <div style={{ color: 'red' }}>{t('Invalid code, please try again.')}</div>}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Button type="primary" size="large" onClick={approve}>{t('Submit')}</Button>
                            <Button type="link" onClick={() => { setSent(false); setError(false); }}>{t('Resend')}</Button>
                        </div>
                    </Space>
                )}
            </Modal>
        </>
    );
}
